<template>
  <div v-if="document">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          v-on="on"
          @click.stop="open"
          data-cy="operatingInstruction"
        >
          picture_as_pdf
        </v-icon>
      </template>
      <span>{{ document.label }}</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  props: ["item"],
  computed: {
    //only one of the two references is ever set
    document() {
      const uploaded = this.item?.operatingInstruction;
      if (uploaded && typeof uploaded === "object") {
        return { type: "file", label: uploaded.name, value: uploaded };
      }

      const generated = this.item?.betriebsanweisung;
      if (generated && typeof generated === "object") {
        return {
          type: "betriebsanweisung",
          label: generated.title,
          value: generated,
        };
      }

      return null;
    },
  },
  methods: {
    open() {
      if (!this.document) return;
      if (this.document.type === "file") return this.downloadFile();
      return this.downloadBetriebsanweisung();
    },
    async downloadFile() {
      const file = this.document.value;
      const path = `Betriebsanweisungen/${file.name}_${file.location}.${file.filetype}`;
      const url = await this.$store.dispatch("getPresignedDownloadUrl", path);
      if (url) window.open(url, "_blank");
    },
    async downloadBetriebsanweisung() {
      const document_ = this.document.value;
      const result = await this.$store.dispatch(
        "getBetriebsanweisungPdf",
        document_._id || document_.id
      );
      if (!result?.base64) return;

      const link = window.document.createElement("a");
      link.href = "data:application/pdf;base64," + result.base64;
      link.download = `${document_.title || "Betriebsanweisung"}.pdf`;
      window.document.body.appendChild(link);
      link.click();
      window.document.body.removeChild(link);
    },
  },
};
</script>
